import isEmpty from 'lodash/isEmpty';
import { setStringInStorage } from '../../services/storageService';
import { activeClientConfig } from '../../services/authService';
import { Config } from '../../constants/clientConfig';

export const setClientConfigToStorage = (tenantConfig) => {
  const { uiConfigId } = tenantConfig;
  if (!isEmpty(uiConfigId)) {
    const extractedUIConfig = uiConfigId.split('.')[1];
    setStringInStorage(activeClientConfig, extractedUIConfig);
    Config.setActiveConfig = extractedUIConfig;
    document.title =
      extractedUIConfig === 'bnysat'
        ? 'BNY SAT (Synthetic Agency TRS)'
        : extractedUIConfig === 'finOptSys'
          ? 'FinOptSys ATRS'
          : '';
  }
};
